import { render, staticRenderFns } from "./OverviewNav.vue?vue&type=template&id=4dd93242&"
import script from "./OverviewNav.vue?vue&type=script&lang=js&"
export * from "./OverviewNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports